import React from 'react'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField'

let username = ''
let password = ''

export default ({onLogin}) =>
  <div>
    <Typography type='title' component='h1'>
      Login
    </Typography>

    <TextField
      onChange={e => (username = e.target.value)}
      label='Username'
      fullWidth
    />
    <TextField
      type='password'
      onChange={e => (password = e.target.value)}
      label='Password'
      fullWidth
    />

    <Button
      variant='raised'
      color='primary'
      onClick={() => onLogin(username, password)}
    >Login</Button>
  </div>



// WEBPACK FOOTER //
// ./src/login/Login.js